import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { MsalService } from '@azure/msal-angular';
import { BsModalService } from 'ngx-bootstrap/modal';
import { ConfirmationService, MessageService } from 'primeng/api';
import { AuthService } from '../../service/auth-service/auth-service.service';
import { DisclaimerComponent } from '../disclaimer/disclaimer.component';
import { OrganisationLoadingStatusEnum } from './OrganisationLoadingStatusEnum';
import { environment } from '../../../../environments/environment';
import { LoggerService } from '../../service/logger-service/logger.service';
import { Util } from '../../ui/Util';

@Component({
  selector: 'app-organisation-selector',
  templateUrl: './organisation-selector.component.html',
  styleUrls: ['./organisation-selector.component.css']
})
export class OrganisationSelectorComponent implements OnInit {

  isDisabled: boolean = false;
  isChecked: boolean = false;
  searchText = '';
  userid = "";
  userReady = OrganisationLoadingStatusEnum.Not_started;
  selectedItem: any;
  items: any[] = [];
  OrganisationLoadingStatus = OrganisationLoadingStatusEnum; // Exposing the enum to the template

  constructor(private router: Router,
    public authService: AuthService,
    private modalService: BsModalService,
    private messageService: MessageService,
    private loggerService: LoggerService,
    private confirmationService: ConfirmationService
  ) {

  }


  ngOnInit() {

    this.authService.resetPrincipal();

    this.authService.getUserLabelObservable().subscribe(userid => {

      if (userid === 'Unknown') {
        this.userReady = OrganisationLoadingStatusEnum.Failed;
        this.loggerService.err('Invalid EMA User identifier');
        this.showTooltipMessage({ severity: 'error', detail: `Invalid EMA User identifier`, life: environment.errorElapsedTime });
      } else if (userid !== '') {
        //Retrieve user organisations
        this.authService.getUserOrganisations()
          .subscribe(

            (data: any[]) => {
              data.forEach(item => {
                let label = "";
                let org_type = "";
                if (item.hierarchyType == "HQ") {
                  org_type = " (HQ) - ";
                  label = item.omsOrgId + org_type + item.name + " - " + item.code;
                } else {
                  if (item.hierarchyType == "VA") {
                    org_type = " (VA) - ";
                    label = item.omsOrgId + org_type + item.name + " - " + item.code + " // [" + item.organisationIdHQ + " (HQ)]";
                  } else {
                    org_type = " (AFF) - ";
                    label = item.omsOrgId + org_type + item.name + " - " + item.code + " // [" + item.organisationIdHQ + " (HQ)]";
                  }
                }
                this.items.push({ "label": label, "id": item.code, "hasAcceptedTerms": item.termsAccepted, "type": item.type, "orgName": item.name, "orgType": org_type });
              });
              if (this.items.length > 0) {
                this.selectedItem = this.items[0];
                this.isChecked = (this.items[0].hasAcceptedTerms === 1);
                this.isDisabled = this.isChecked;
                this.userReady = OrganisationLoadingStatusEnum.Successful;
              } else {
                this.userReady = OrganisationLoadingStatusEnum.Failed;
                this.loggerService.err(`The user [${userid}] is not assigned to any organisation`);
                this.showTooltipMessage({ severity: 'error', detail: `Your user is not assigned to any organisation`, life: environment.errorElapsedTime });
              }
            },
            (error) => {
              this.userReady = OrganisationLoadingStatusEnum.Failed;
              this.loggerService.err('An error occured when initializing application. (OrganisationSelectorComponent.ngOnInit)', error);
              this.showTooltipMessage({ severity: 'error', detail: `An error occured when initializing application\n\n${this.getErrorUserInfo(error)}`, life: environment.errorElapsedTime });
            });
      }
    });

    Util.markAppAsReady();
  }

  get filteredItems() {
    if (!this.searchText) {
      return this.items;
    }
    return this.items.filter(item => item.label.toLowerCase().includes(this.searchText.toLowerCase()));
  }

  selectItem(item: any) {
    this.selectedItem = item;
    this.searchText = '';
    this.isChecked = (item.hasAcceptedTerms === 1);
    this.isDisabled = this.isChecked;
  }

  getErrorUserInfo(error?: any) {
    const currentTimestamp = new Date();
    const errorStatus = error && error.status ? `Http status: ${error.status}` : '';
    return `Logged user: ${this.authService.getUserName()}\nTimestamp: ${currentTimestamp}\n${errorStatus}`;
  }

  onSelectOrganisation() {

    this.authService.getUserData(this.selectedItem.id).subscribe(
      (data: any) => {
        if (data.errors && data.errors.length > 0) {
          let errorMessage = data.errors.map((item: string) => `<li>${item}</li>`).join('')
          this.confirmationService.confirm({
            message: `We found some issues during your login process:<br><ul>${errorMessage}</ul>`,
            header: 'Login access result',
            icon: 'pi pi-exclamation-triangle',
            acceptLabel: 'Accept',
            rejectVisible: false,
            accept: () => { }
          });
        } else {
          if (data.user) {
            this.authService.initializeSessionWithPrincipal(data.user);
            this.router.navigate(['/']);
            this.showOrgInfo(this.selectedItem.orgType, this.selectedItem.orgName);
          }
        }
      },
      (error) => {
        this.loggerService.err('An error occured when submitting the selected organisation. (OrganisationSelectorComponent.onSelectOrganisation)', error);
        this.showTooltipMessage({ severity: 'error', detail: `An error occured when submitting the selected organisation\n\n${this.getErrorUserInfo(error)}`, life: environment.errorElapsedTime });
      }
    );
  }

  showTermsOfUse() {
    this.authService.getTermsofUse(this.selectedItem.type).subscribe(
      (data) => {
        const initialState = {
          content: data.name
        };
        this.modalService.show(DisclaimerComponent, { initialState }).setClass('modal-xl');

      });
  }

  showOrgInfo(org_type: string, org_name: string) {
    this.authService.showOrgInfo(org_type, org_name);
  }

  onRefreshLogin() {
    this.ngOnInit();
  }

  showTooltipMessage(messageStructure: any) {
    this.messageService.add(messageStructure);
  }

}
